module.exports = __webpack_public_path__ + "img/testimonial-3.1dc3ba6f.jpg";